import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { OfferState } from 'ng2-app/store/offers/offer.state';
import { Contact } from 'ng2-app/models/dto/contact.model';
import { ResendAdditionalOwnerPostOfferVerification } from 'ng2-app/store/additional-owner/additional-owner.actions';

@Component({
  selector: 'app-additional-owners-post-offer-verification',
  templateUrl: './additional-owners-post-offer-verification.component.html',
  styleUrls: ['./additional-owners-post-offer-verification.component.scss'],
  standalone: false,
})
export class AdditionalOwnersPostOfferVerificationComponent implements OnInit {

  @Input() borrowerId: number;
  @Input() contacts: Contact[];
  @Output() resendPostOfferVerificationComplete = new EventEmitter<void>();

  constructor(private store: Store) { }

  ngOnInit() {
  }

  canResendAdditionalOwnerPostOfferVerification(): boolean {
    const eligibleContacts = this.contacts.filter(contact => contact.percentOwnership && contact.percentOwnership >= 20);
    const hasAcceptedOffer = this.store.selectSnapshot(OfferState.hasAcceptedAnyOffer);
    return eligibleContacts.length > 1 && hasAcceptedOffer;
  }

  resendPostOfferVerificationRequest() {
    this.resendPostOfferVerificationComplete.emit();
    this.store.dispatch(new ResendAdditionalOwnerPostOfferVerification(this.borrowerId)).subscribe(() => {
      this.resendPostOfferVerificationComplete.emit();
    });
  }
}

